module.exports = __webpack_public_path__ + "img/IMG_1868.045f064f.jpeg";